const CARD_DECLINED_CODE = 'card_declined';
const AUTHENTICATION_CODE_PREFIX = 'payment_intent_authentication';

/**
 * Turns the provider's refusal code into a translation key the brand can act on.
 * Anything we cannot name stays generic rather than exposing a provider code.
 */
export function resolvePaymentFailureReasonKey(code: string | null): string {
  if (code === CARD_DECLINED_CODE) {
    return 'payouts.failure.reason.cardDeclined';
  }

  if (code?.startsWith(AUTHENTICATION_CODE_PREFIX)) {
    return 'payouts.failure.reason.authentication';
  }

  return 'payouts.failure.reason.generic';
}
